module.exports = __webpack_public_path__ + "static/media/customer_Img_Jayanthi_Agency.4acc3055.jpeg";